import { useEffect, useRef } from 'react';
import { Analytics } from '@invideoio/web-shared/utils/analytics';
import {
  AnalyticsConfig,
  AnalyticsType,
} from '@invideoio/web-shared/types/Analytics';
import { isUserLoggedIn } from '@utils/common.utils';
import { AnalyticsUtils } from '@invideoio/web-shared/utils/analytics/AnalyticsUtils';
import { UserType } from '@invideoio/web-shared/types/Auth';
import { setCommonAnalyticsProperties } from '@utils/analytics';
import { PlatformType } from '@invideoio/web-shared/constants/common';

const analyticsConfig: AnalyticsConfig[] = [
  {
    name: AnalyticsType.AMPLITUDE,
    config: {
      AMPLITUDE_ID: process.env.NEXT_PUBLIC_AMPLITUDE_ID,
    },
  },
  {
    name: AnalyticsType.RUDDER_STACK,
    config: {
      WRITE_KEY: process.env.NEXT_PUBLIC_RUDDER_STACK_WRITE_KEY,
      DATA_PLANE_URL: process.env.NEXT_PUBLIC_RUDDER_STACK_DATA_PLANE_URL,
      CONFIG_URL: process.env.NEXT_PUBLIC_RUDDER_STACK_CONFIG_URL,
    },
  },
];

function LoadAnalytics({
  userData,
  platform,
  isGoogleBot,
}: {
  userData: UserType | null;
  platform: PlatformType;
  isGoogleBot: boolean;
}) {
  const hasAnalyticsLoaded = useRef(false);

  useEffect(() => {
    if (!hasAnalyticsLoaded.current) {
      setCommonAnalyticsProperties();
      // pushing GTM, Tapaffiliate and FBQ only for non google bot
      if (!isGoogleBot) {
        analyticsConfig.push({
          name: AnalyticsType.GTM,
          config: {
            GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
          },
        });

        analyticsConfig.push({
          name: AnalyticsType.TAPFILIATE,
        });
        analyticsConfig.push({
          name: AnalyticsType.FBQ,
        });
      }

      if (isUserLoggedIn() && userData) {
        analyticsConfig.push({
          name: AnalyticsType.BRAZE,
          config: {
            API_KEY: process.env.NEXT_PUBLIC_BRAZE_API_KEY,
          },
        });

        AnalyticsUtils.userData = userData;

        Analytics.init(analyticsConfig);
        hasAnalyticsLoaded.current = true;
      } else if (!isUserLoggedIn()) {
        Analytics.init(analyticsConfig);
        hasAnalyticsLoaded.current = true;
      }
    }
  }, [hasAnalyticsLoaded, userData, platform, isGoogleBot]);

  return null;
}

export default LoadAnalytics;
